export default __webpack_public_path__ + "static/media/welcome_screen.30af0f22.jpg";